module.exports = __webpack_public_path__ + "media/GLAMPING_6.3a2919d3.mp4";